let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jRam1")).then(() => parcelRequire('lKRQ7'));